<div class="wrapper wrapper-content ng-scope animated fadeInRight">
  <div class="row error-msg">
    <div class="col-12">
      <div [ngClass]="iconClass"></div>
      <p class="message-title">{{tittleKey | translate}}</p>
      <p class="message-summary" [innerHTML]="translate.instant(messageKey)" *ngIf="messageKey"></p>
      <p class="message-summary" *ngIf="!messageKey">{{message}}</p>
      <ng-content></ng-content>
    </div>
  </div>
</div>